module.exports = __webpack_public_path__ + "img/xiazai.ae4f2344.png";